module.exports = __webpack_public_path__ + "static/media/bn_banner.ffdccf35.png";